import React, { useEffect, useState } from 'react';

import { getBytesStrapiUrl } from '@lib/bytesStrapiServices';
import { dateFormat } from '@utils/functions/readingTime';
import axios from 'axios';
import { useRouter } from 'next/router';
import CustomStripBanner from './CustomStripBanner';
import dynamic from 'next/dynamic';
// import RevampedDemoClassStrip from './RevampedDemoClassStrip';
import YearRemindBanner from './YearRemindBanner';
import EuroScholarship from './EuroScholarship';
import RevampedDemoClassStrip from './RevampedDemoClassStrip';
import CustomCourseBanner from './CustomCourseBanner';

const DemoClassStrip = dynamic(() => import('@components/shared/header/DemoClassStrip'), {
  ssr: false,
});

const EventStripBanner = dynamic(() => import('@components/shared/header/StripBanner'), {
  ssr: false,
});
const EventBanner = dynamic(() => import('@components/shared/header/EventBanner'), {
  ssr: false,
});
async function fetchCampaignData(slug) {
  try {
    const apiBaseUrl = getBytesStrapiUrl();

    const date = new Date();

    const today = dateFormat(date);

    let URL = `${apiBaseUrl}/api/strip-banners?populate=pages&filters[$and][0][expiryDate][$gte]=${today}&filters[$and][0][pages][slug][$eq]=${slug}`;

    // if (slug === 'home') {
    // URL += `&filters[$and][0][pages][slug][$eq]=${slug}`;
    // } else {
    //   URL += `&filters[$and][0][pages][slug][$contains]=${slug}`;
    // }

    const { data } = await axios.get(URL);

    const campaignData = data?.data[0]?.attributes;

    if (!campaignData) {
      return null;
    }

    console.log('Active Campaign', '------>', slug);

    return campaignData;
  } catch (error) {
    console.log('CAMPAIGN_STRIP', error);
  }
}

function DynamicStripBanner({
  isDemoClass = false,
  isPlacement,
  isEuroScholarship,
  isDataScience,
  isMasterDs,
  isSoftwareEngineering,
  isMasterCloudComputing,
}) {
  const [campaignData, setCampaignData] = useState(null);
  const [isLoading, setLoading] = useState(true);

  const router = useRouter();

  const fetchData = async () => {
    try {
      const endpoint = router.asPath.split('/').pop();

      const data = await fetchCampaignData(endpoint || 'home');

      setCampaignData(data);
    } catch (err) {
      console.log('FETCH_CAMP_ERR', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    return () => {
      setCampaignData(null);
      setLoading(true);
    };
  }, [router]);

  if (isPlacement) {
    return <YearRemindBanner />;
  }
  if (isLoading) return <></>;
  // if (isDataScience || isMasterDs) {
  //   return <CustomCourseBanner />;
  // }

  if (isSoftwareEngineering || isMasterCloudComputing) {
    return (
      <CustomCourseBanner
        title="From Non-Tech to Software Engineer in 2025"
        date="May 24"
        registerLink="https://link.almabetter.com/U381"
      />
    );
  }

  if (!!campaignData) {
    return <CustomStripBanner campaignData={campaignData} />;
  }
  // if (isEuroScholarship) {
  //   return <EuroScholarship />;
  // }
  if (isPlacement) {
    return <YearRemindBanner />;
  }

  if (isDemoClass) {
    // return <DemoClassStrip />;
    return <RevampedDemoClassStrip />;
    // return <EventBanner />;
  }

  return <EventStripBanner />;
}

export default DynamicStripBanner;
